// Pure helpers for WorkoutColumn, split out so they can be unit-tested without mounting React.
// See the "Autosave suppression" section of
// docs/plans/multi-workout-builder-add-blocks-and-movements.md for the contract this implements.

// Returns a NEW program object suitable for POSTing to WorkoutAdmin/SaveProgram:
// - drops any movement whose movementId is falsy (0/null/undefined) — an unselected row — and
//   re-sequences the survivors within their category.
// - drops any category left with zero movements after pruning (a blank/incomplete block), and
//   re-sequences the surviving categories.
// - never mutates the input `program`; always returns a fresh object/array tree for the parts
//   that changed.
export function sanitizeProgramForSave(program) {
  if (!program) return program;

  const categories = program.categories
    .map((c) => {
      const movements = (c.movements || [])
        .filter((m) => !!m.movementId)
        .map((m, i) => ({ ...m, seq: i + 1 }));
      return { ...c, movements };
    })
    .filter((c) => c.movements.length > 0)
    .map((c, i) => ({ ...c, category: { ...c.category, seq: i + 1 } }));

  return { ...program, categories };
}
